import { ApiResponse } from '@core/models/api-response.model';
import { tap, map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '@core/models/pagination.model';
import { Injectable } from '@angular/core';
import { SystemSetting } from '@core/models/system-setting.model';

@Injectable()
export class SystemSettingDataService {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(private http: HttpClient) { }

  getWithQuery(pageParam: string): Observable<SystemSetting[]> {
    return this.http.get<ApiResponse>(`/systemsetting${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  update(systemSetting: any) {
    return this.http.put<ApiResponse>(`/systemsetting`, systemSetting).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }
}
